<div class="pre_loader_bg" *ngIf="loading">
    <div class="pre_loader"></div>
</div> 